import { MeetingResponse } from '@/types';

export const groupMeetingsByAddress = (meetings: MeetingResponse[]) => {
  if (!meetings.length) return [];

  const groupedMeetings = meetings.reduce(
    (acc, meeting) => {
      const address = meeting.address;
      if (!acc[address]) {
        acc[address] = [];
      }
      acc[address].push(meeting);
      return acc;
    },
    {} as Record<string, MeetingResponse[]>
  );
  return Object.values(groupedMeetings);
};
